import { usePintMaster, createControlField } from '@lib/common';
import { TextField } from '@material-ui/core';
import { blue } from '@material-ui/core/colors';
import { Autocomplete } from '@material-ui/lab';
import { useEffect, useState } from 'react';
import styled from 'styled-components';

const StatusAutoComplete = ({ value, onChange, ...props}) => {
  const { loading, master: status } = usePintMaster('status');
  const [statusVal,setStatusVal] = useState(null);

  useEffect(() => {
    if(value && !loading && status) {
      const valueObj = status.filter(item => item?.name === (value?.name || value))
      setStatusVal(valueObj[0] || null)
    } else if (!value) {
      setStatusVal(null)
    }
  },[loading, value, status])

  return (
    <Styles>
      <Autocomplete
        size="small"
        fullWidth
        value={statusVal}
        onChange={(evt, v) => {
          setStatusVal(v);
          return onChange && onChange(v)}
        }
        loading={loading}
        disabled={loading}
        options={status || []}
        getOptionLabel={value => value?.name || ''}
        getOptionSelected={(option, value) => {
          return option?.name === value?.name}
        }
        {...props}
        renderInput={props => (
          <TextField
            helperText="Select the status of this content."
            label={loading ? 'Status (Loading...)' : 'Status'}
            placeholder={loading ? 'Status (Loading...)' : 'Status'}
            fullWidth
            variant="outlined"
            {...props}
          />
        )}
      />
    </Styles>
  );
};

const Styles = styled.div`
  .MuiChip-root {
    background: ${blue[600]};
    color: white;
  }
  .MuiChip-deleteIcon {
    color: white;
  }
`;

export const ContentStatusField = createControlField(StatusAutoComplete, "");
